import { render, staticRenderFns } from "./Fund.vue?vue&type=template&id=01bc82b2&"
import script from "./Fund.vue?vue&type=script&lang=js&"
export * from "./Fund.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports